export const NAME = 'audioAbbreviations';
